const initialState = {
    loading: false,
    numCurrentBlessings: 0,
    blessingCeil: 0,
    currentBlesser: 0,
    currentState: 0,
    walletCanBless:false,
    nfts:[],
    error: false,
    errorMsg: "",
};

const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        case "CHECK_DATA_REQUEST":
            return {
                ...state,
                loading: true,
                error: false,
                errorMsg: "",
            };
        case "CHECK_DATA_SUCCESS":
            return {
                ...state,
                loading: false,
                ...(action.payload),
                // cost: action.payload.cost,
                error: false,
                errorMsg: "",
            };
        case "CHECK_DATA_FAILED":
            return {
                ...initialState,
                loading: false,
                error: true,
                errorMsg: action.payload,
            };
        default:
            return state;
    }
};

export default dataReducer;
